import {
  Gstr3bComputationResponseSchema,
  Gstr3bReturnResponseSchema,
  type PutReversals,
  type PutReverseCharge,
} from '@oneapp/shared';
import { api } from '../lib/api';

const withSignal = (signal?: AbortSignal) => (signal ? { signal } : {});
const enc = encodeURIComponent;
/** The return's version, for If-Match: answers changed elsewhere (the chat, another phone) aren't overwritten. */
const ifMatch = (version: number) => ({ 'If-Match': `"${version}"` });

/** GSTR-3B (Phase 10; see packages/shared/src/api.ts), as the signed-in person. */
export const gstr3bApi = {
  get: (returnId: string, signal?: AbortSignal) =>
    api.get(`/api/v1/returns/${enc(returnId)}`, Gstr3bReturnResponseSchema, { auth: true, ...withSignal(signal) }),

  reverseCharge: (returnId: string, body: PutReverseCharge, version: number) =>
    api.put(`/api/v1/returns/${enc(returnId)}/rcm-entries`, Gstr3bReturnResponseSchema, {
      auth: true,
      body,
      headers: ifMatch(version),
    }),

  reversals: (returnId: string, body: PutReversals, version: number) =>
    api.put(`/api/v1/returns/${enc(returnId)}/itc-reversals`, Gstr3bReturnResponseSchema, {
      auth: true,
      body,
      headers: ifMatch(version),
    }),

  computation: (returnId: string, signal?: AbortSignal) =>
    api.get(`/api/v1/returns/${enc(returnId)}/computation`, Gstr3bComputationResponseSchema, {
      auth: true,
      ...withSignal(signal),
    }),
};

export const gstr3bKeys = {
  return: (returnId: string) => ['gstr3b', returnId] as const,
  computation: (returnId: string) => ['gstr3b', returnId, 'computation'] as const,
};
